import type { LinkUrl, NavigationLinkwithiconComponent } from '@twisto/api-cms'
import { Link } from '@twisto/components/atoms/link'
import { Typography } from '@twisto/components/atoms/typography'
import { OnlineShoppingIcon, UserOutlineIcon } from '@twisto/icons'
import { styleUtils } from '@twisto/styles'

import { getLinkUrl } from 'homepage/utils'

import * as styles from '../secondary-navigation-slot.styles'

type Props = {
  link: NavigationLinkwithiconComponent
  increaseFontSize?: boolean
}

const getIcon = (link: NavigationLinkwithiconComponent['icon']) => {
  switch (link) {
    case 'shopping':
      return <OnlineShoppingIcon css={styles.icon} height="24" width="24" />
    case 'user':
      return <UserOutlineIcon css={styles.icon} height="24" width="24" />
    default:
      return null
  }
}

export const LinkWithIcon = ({ link, increaseFontSize = false }: Props) => (
  <li>
    <Link
      href={link.url}
      target={link.newTab === true ? '_blank' : undefined}
      to={getLinkUrl(link as LinkUrl)}
      underline="hover"
    >
      <Typography
        component="span"
        css={styleUtils.textAlign.center}
        fontWeight="medium"
        variant={increaseFontSize ? 'b2' : 'b3'}
      >
        {getIcon(link.icon)}
        {link.text}
      </Typography>
    </Link>
  </li>
)
